import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { Router } from '@angular/router';
import { ModalController, NavController, PopoverController } from '@ionic/angular';
import { Storage } from '@ionic/storage';
import { AccountPaymentFavoriteDTO, AccountPaymentFavoriteService, TypeEnum } from '@wlp/ui-bs-account-payment-favorite';
import { transactionSchedule, TransferService } from '@wlp/ui-bs-cashout';
import { UserInfoService } from '@wlp/ui-bs-login';
import { UserInfoProfile } from '@wlp/ui-bs-login/lib/dto/user-info-profile';
import { UiBsMyDataService } from '@wlp/ui-bs-my-data';
import { of } from 'rxjs';
import { catchError, retry, tap } from 'rxjs/operators';
import { LoadingService } from 'src/app/core/layout/services/loading.service';
import { PopoverFavoritesComponent } from 'src/app/views/themes/sentinel/modals/popover-favorites/popover-favorites.component';

import { FavoritesDataFilterPipe } from '../../favorites-data-filter.pipe';
import { ModalAlertComponent } from './../../../../../../modals/modal-alert/modal-alert.component';
import { ModalSearchBankComponent } from './../../../../../../modals/modal-search-bank/modal-search-bank.component';
import { ModalTokenComponent } from './../../../../../../modals/modal-token/modal-token.component';
import { ModalTransferResumeComponent } from './../../../../../../modals/modal-transfer-resume/modal-transfer-resume.component';
import { CpManagerBasePage } from '../../../../cp-manager-base.page';

@Component({
  selector: 'app-other-accounts-favorites',
  templateUrl: './other-accounts-favorites.page.html',
  styleUrls: ['./other-accounts-favorites.page.scss'],
  providers: [FavoritesDataFilterPipe],
})
export class OtherAccountsFavoritesPage extends CpManagerBasePage implements OnInit {
  public formTransfer: FormGroup;
  public errorMessages: any;
  public bankList: Array<any>;
  ownerShip: boolean;
  public switchFavorites: any = 'new';
  responseTransfer: any;
  listReceiptsShow: any;
  selectedFavorite: boolean;
  disabledToogle: boolean;
  toogleFavorite: any;
  realm: any;
  public param: object;

  private readonly OPERATION: string = '120';
  private readonly LIST_DATES: string = '1';
  private readonly PERMIT_OPERATION: string = '3';

  private datesSchedule: transactionSchedule;

  private permitTransaction: boolean = false;
  private transferData: any;

  constructor(
    private navCtrl: NavController,
    private transferService: TransferService,
    private myDataService: UiBsMyDataService,
    private modalController: ModalController,
    protected userInfoService: UserInfoService,
    private loadingService: LoadingService,
    private cdr: ChangeDetectorRef,
    public accountPaymentFavoriteService: AccountPaymentFavoriteService,
    private storage: Storage,
    public router: Router,
    public popoverController: PopoverController,
    public pipeFilter: FavoritesDataFilterPipe
  ) {
    super(userInfoService);
  }

  public async ngOnInit() {
    /* this.realm = this.accountPaymentFavoriteService.realmValidation(environment.wlThemeParameterization.wlTheme.realm.toUpperCase()); */
    this.realm = true;
    this.errorMessages = this.transferService.getFormMessageError();
    this.formTransfer = this.transferService.createFormTransfer();
    await this.loadUser();

    this.transferService
      .checkDayResource(this.userProfile.uuidWhiteLabel, this.OPERATION, this.LIST_DATES)
      .subscribe((res) => {
        this.datesSchedule = res;
      });
    this.ownerShip = false;

    this.completeLoad();
  }

  ionViewWillEnter() {
    this.resetForm();
  }

  private completeLoad() {
    this.transferService.setTransferFlow('TED');
    this.storage.remove('typeTransfer');
    this.storage.set('typeTransfer', 'TED').then(() => {});

    this.transferService
      .checkDayResource(this.userProfile.uuidWhiteLabel, this.OPERATION, this.PERMIT_OPERATION)
      .subscribe((res) => {
        this.param = {
          startTime: res.startTime,
          endTime: res.endTime,
        };
        this.permitTransaction = res.dateValid;
      });
  }

  public sameOwnership(event) {
    if (this.ownerShip === false) {
      this.ownerShip = true;
      this.myDataService.getPersonalData(this.userProfile.uuidAccount).subscribe(
        (res) => {
          this.formTransfer.controls.document.setValue(this.formatCnpjCpf(res.document));
          this.formTransfer.controls.name.setValue(res.name);
        },
        (error) => {
          console.error(error);
        }
      );
    } else {
      this.formTransfer.controls.document.setValue('');
      this.formTransfer.controls.name.setValue('');
      this.ownerShip = false;
      this.cdr.detectChanges();
    }
  }

  checkValue(value) {
    if (/^0/.test(value)) {
      this.formTransfer.controls.transferValue.reset();
      return;
    }

    value = value.replace(/[^\w\s]/gi, '');
    value = parseFloat(value);

    if (value < 1000) {
      this.formTransfer.controls.transferValue.setErrors({ invalid10: true });
    }
  }

  public checkForm() {
    if (this.formTransfer.status === 'VALID') {
      return false;
    } else {
      return true;
    }
  }

  // Validar o horário da operação
  public async validateTime() {
    const modalStatus = await this.modalController.create({
      component: ModalAlertComponent,
      cssClass: 'modal-validate-time',
      componentProps: {
        status: 'warning-circle',
        message: 'CASH_OUT.TRANSFER_OTHER_ACCOUNT.MESSAGES.CONFIRM_SCHEDULE',
        description: 'CASH_OUT.TRANSFER_OTHER_ACCOUNT.MESSAGES.CONFIRM_SCHEDULE_DETAILS',
        confirmBtn: 'CASH_OUT.TRANSFER_OTHER_ACCOUNT.BUTTONS.CONFIRM_BUTTON',
        cancelBtn: 'CASH_OUT.TRANSFER_OTHER_ACCOUNT.BUTTONS.CANCEL_BUTTON',
        confirmation: true,
        translate: true,
        param: this.param,
      },
      backdropDismiss: false,
    });
    modalStatus.onDidDismiss().then((data) => {
      if (data.data === true) {
        this.goToResume();
      } else {
        this.navCtrl.navigateRoot('app/dashboard');
      }
    });
    return await modalStatus.present();
  }

  public validateOperation() {
    this.formTransfer.controls.typeTransfer.setValue('TED');
    this.transferService.setTransfer(this.formTransfer);
    this.saveFavorite(this.toogleFavorite);
    /**
     ** A verificação do saldo está rodando no backend.
     */
    if (this.permitTransaction) {
      this.goToResume();
    } else {
      this.validateTime();
    }
  }

  // private checkDayResource(uuidWhiteLabel: string, code: string, type: string) {
  //   this.transferService.checkDayResource(uuidWhiteLabel, code, type).subscribe((res) => {
  //     this.datesSchedule = res;
  //     console.log(res);
  //   });
  // }

  public async goToResume() {
    const modalResume = await this.modalController.create({
      component: ModalTransferResumeComponent,
      cssClass: 'modal-resume',
      componentProps: {
        datesSchedule: this.datesSchedule,
        permitTransaction: this.permitTransaction,
      },
    });
    modalResume.onDidDismiss().then((data) => {
      if (data['data'] === true) {
        this.token();
      }
    });
    return await modalResume.present();
  }

  public async token() {
    this.transferService.getTransfer().subscribe((res) => {
      this.transferData = res;
    });

    const modalToken = await this.modalController.create({
      component: ModalTokenComponent,
      cssClass: 'modal-token',
      componentProps: {
        codeOperation: this.OPERATION,
      },
    });
    modalToken.onDidDismiss().then((data) => {
      if (data['data']) {
        this.sendTransaction(data['role']);
      }
    });
    return await modalToken.present();
  }

  public async sendTransaction(token: string) {
    this.loadingService.show();
    await this.transferService
      .sendTransaction(this.userProfile.uuidWhiteLabel, this.userProfile.uuidAccount, token)
      .then((res) => {
        console.log("sendtransaction", res)
        const response = res;
        if (response !== null) {
          if (response.isExecuted && !this.transferData.scheduled && !response.approveFlow) {
            this.notification('success', 'CASH_OUT.TRANSFER_OTHER_ACCOUNT.MESSAGES.SUCCESS', false);
            return;
          }
          if (response.isExecuted && this.transferData.scheduled && !response.approveFlow) {
            this.notification(
              'success',
              'CASH_OUT.TRANSFER_OTHER_ACCOUNT.MESSAGES.SCHEDULING_SUCCESSFUL',
              false,
              response.scheduled
            );
            return;
          }
          if (response.isExecuted && response.approveFlow) {
            this.notification(
              'warning-circle',
              'CASH_OUT.TRANSFER_ON_US.MESSAGES.REQUEST_APPROVAL',
              false,
              response.scheduled
            );
            return;
          }
          if (!response.isExecuted) {
            switch (response.message) {
              case 'Operação não realizada, tente novamente mais tarde':
                this.notification(
                  'warning-circle',
                  'CASH_OUT.TRANSFER_OTHER_ACCOUNT.MESSAGES.FAILED_NOT_EXECUTED',
                  false
                );
                break;
              case 'Operação fora de horário':
                this.notification('warning-circle', 'CASH_OUT.TRANSFER_OTHER_ACCOUNT.MESSAGES.OUT_OF_TIME', false);
                break;
              case 'LIMITE DE OPERAÇÃO EXCEDIDO EXCEDIDO':
                this.notificationLimit();
                break;
              case 'Codigo de operação invalido':
                this.notification('warning-circle', 'CASH_OUT.TRANSFER_OTHER_ACCOUNT.MESSAGES.INVALID_CODE', false);
                break;
              default:
                this.notification('warning-circle', response.message, false);
            }
          } else {
            this.notification('warning-circle', 'CASH_OUT.TRANSFER_OTHER_ACCOUNT.MESSAGES.FAILED', false);
          }
        } else {
          this.notification('warning-circle', 'CASH_OUT.TRANSFER_OTHER_ACCOUNT.MESSAGES.FAILED', false);
        }
      })
      .catch((err) => {
        this.transferService.getErrorTransfer(err);
        this.notification('warning-circle', 'CASH_OUT.TRANSFER_OTHER_ACCOUNT.MESSAGES.FAILED', false);
      });
  }

  public async notification(status: string, message: string, confirmation?: boolean, scheduled?: boolean) {
    this.loadingService.hide();

    const modalStatus = await this.modalController.create({
      component: ModalAlertComponent,
      cssClass: 'modal-alert-class',
      componentProps: {
        status: status,
        message: message,
        confirmBtn: 'CASH_OUT.TRANSFER_OTHER_ACCOUNT.BUTTONS.CLOSE',
        confirmation: confirmation,
        translate: true,
      },
      backdropDismiss: false,
    });
    modalStatus.onDidDismiss().then((data) => {
      if (status === 'success') {
        if (scheduled === true) {
          this.navCtrl.navigateRoot(['app/charging/transfer/receipt/true']);
        } else {
          this.navCtrl.navigateRoot(['app/charging/transfer/receipt/false'], {
            queryParams: { typeRoute: 'other' },
          });
        }
      } else {
        this.navCtrl.navigateRoot('app');
      }
    });
    return await modalStatus.present();
  }

  public async notificationLimit() {
    this.loadingService.hide();
    const modalStatus = await this.modalController.create({
      component: ModalAlertComponent,
      cssClass: 'modal-validate-time',
      componentProps: {
        status: 'warning-circle',
        message: 'CASH_OUT.TRANSFER_OTHER_ACCOUNT.MESSAGES.LIMIT_OPERATION',
        description: 'CASH_OUT.TRANSFER_OTHER_ACCOUNT.MESSAGES.LIMIT_OPERATION_DETAILS',
        confirmBtn: 'CASH_OUT.TRANSFER_OTHER_ACCOUNT.BUTTONS.CLOSE',
        confirmation: false,
        translate: true,
      },
      backdropDismiss: false,
    });
    return await modalStatus.present();
  }

  public async searchBank() {
    const modalBank = await this.modalController.create({
      component: ModalSearchBankComponent,
      cssClass: 'modal-search-bank',
    });
    modalBank.onDidDismiss().then((data) => {
      if (data['data']) {
        this.formTransfer.controls.bank.setValue(data['data'].name);
        this.formTransfer.controls.bankCode.setValue(data['data'].code);
      }
    });
    return await modalBank.present();
  }

  private formatCnpjCpf(value: string) {
    const document = value.replace(/\D/g, '');
    if (document.length === 11) {
      return document.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/g, '$1.$2.$3-$4');
    } else if (document.length > 11) {
      return document.replace(/(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/g, '$1.$2.$3/$4-$5');
    } else {
      return value;
    }
  }

  isValid() {
    if (this.formTransfer.invalid) {
      return true;
    } else {
      return false;
    }
  }

  segmentChanged(favorite) {
    this.getAllFavorites();
    this.switchFavorites = favorite;
  }

  getAllFavorites() {
    this.accountPaymentFavoriteService
      .getAllFavoritesType(this.userProfile.uuidWhiteLabel, this.userProfile.uuidAccount, TypeEnum.TED)
      .pipe(
        tap((data) => {
          this.responseTransfer = data;
          this.listReceiptsShow = data.filter(this.checkListAccount);
          // this.listReceiptsShow = this.accountPaymentFavoriteService.orderListFavoritesByName(this.listReceiptsShow);
        }),
        retry(2),
        catchError((_) => {
          return of(null);
        })
      )
      .subscribe();
  }

  async presentPopover(ev: any) {
    const popover = await this.popoverController.create({
      component: PopoverFavoritesComponent,
      cssClass: 'popover-class',
      event: ev.event,
      translucent: true,
      mode: 'md',
    });
    popover.onDidDismiss().then((data) => {
      if (data.data == 'exclude') {
        this.deleteFavorite(ev.favorite);
      }
      if (data.data == 'edit') {
        this.storage.set('favoriteForEdit', ev.favorite).then(() => {
          this.storage.set('favoriteType', 'OTHER-ACCOUNT');
          this.switchFavorites = 'new';
          this.router.navigate(['/app/charging/favorites/transfer']);
        });
      }
    });
    return await popover.present();
  }

  deleteFavorite(favorite) {
    this.loadingService.show();
    this.accountPaymentFavoriteService
      .deleteFavorite(favorite)
      .pipe(
        tap((data) => {
          if (data.status) {
            this.notification('success', 'CASH_OUT.TRANSFER_ON_US.MESSAGES.SUCCESS_FAVORITES_EXCLUDE', false);
            this.getAllFavorites();
          } else {
            this.notification('failed', 'CASH_OUT.TRANSFER_ON_US.MESSAGES.FAILED_FAVORITES', false);
          }
          this.loadingService.hide();
        }),
        catchError((_) => {
          this.loadingService.hide();
          return of(null);
        })
      )
      .subscribe();
  }

  optionsFavorites(favorite) {
    console.log("**********************", favorite)
    this.formTransfer.setValue({
      document: favorite.document,
      name: favorite.name,
      accountType: favorite.typeAccount,
      bank: favorite.bankName,
      branch: favorite.agencyNumber,
      accountNumber: favorite.accountNumber,
      transferValue: '',
      bankCode: favorite.codeBank ? favorite.codeBank : '',
      typeTransfer: '',
      dateSchedule: null,
      scheduled: false,
      uuidAccountPaymentDestination: '',
      uuidWhiteLabelDestination: '',
    });
    this.selectedFavorite = true;
    this.switchFavorites = 'new';
  }

  saveFavorite(checked) {
    if (checked) {
      // this.loadingService.show();
      let prepare: AccountPaymentFavoriteDTO;
      prepare = {
        uuidWhiteLabel: this.userProfile.uuidWhiteLabel,
        uuidAccountPayment: this.userProfile.uuidAccount,
        name: this.formTransfer.controls.name.value,
        document: this.formTransfer.controls.document.value,
        codeBank: this.formTransfer.controls.bankCode.value,
        bankName: this.formTransfer.controls.bank.value,
        accountNumber: this.formTransfer.controls.accountNumber.value,
        agencyNumber: this.formTransfer.controls.branch.value,
        typeAccount: this.formTransfer.controls.accountType.value,
        zipCode: '',
        address: '',
        addressNumber: '',
        addressComplement: '',
        neighborhood: '',
        city: '',
        state: '',
        country: '',
        uuid: '',
        type: TypeEnum.TED,
      };
      this.accountPaymentFavoriteService
        .saveFavorite(prepare)
        .pipe(
          tap((data) => {
            if (data.status) {
              // this.notification('success', 'CASH_OUT.TRANSFER_ON_US.MESSAGES.SUCCESS_FAVORITES', false, true);
            } else {
              // this.notification('failed', 'CASH_OUT.TRANSFER_ON_US.MESSAGES.FAILED_FAVORITES', false);
              // this.toogleFavorite = false;
            }
            // this.loadingService.hide();
          }),
          catchError((_) => {
            // this.loadingService.hide();
            return of(null);
          })
        )
        .subscribe();
    }
  }

  public filterReceipt(value) {
    if (value !== '') {
      this.listReceiptsShow = this.pipeFilter.transform(this.responseTransfer, value);
      return;
    } else {
    }
  }

  checkListAccount(account) {
    return account.codeBank.length >= 1 && account.accountNumber.length >= 1 && account.agencyNumber.length >= 1;
  }

  resetForm() {
    this.formTransfer.controls.document.setValue('');
    this.formTransfer.controls.name.setValue('');
    this.formTransfer.controls.bankCode.setValue('');
    this.formTransfer.controls.bank.setValue('');
    this.formTransfer.controls.accountNumber.setValue('');
    this.formTransfer.controls.branch.setValue('');
    this.formTransfer.controls.accountType.setValue('');
    this.formTransfer.controls.transferValue.reset();
  }
}
